import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const protocolDeviationslogAPI = createApi({
  baseQuery,
  reducerPath: 'protocolDeviationslogAPI',
  endpoints: builder => ({
    getProtocolDeviationsLog: builder.query<any, any>({
      query: ({ deviation_level, site_id, study_id, country, application, from = -1, size = -1, data }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.getAll)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&deviation_level=${deviation_level}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createProtocolDeviationsLog: builder.mutation<any, any>({
      query: ({ deviation_level, data, study_id, country, site_id }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.create, {
          key: urlKeys.study_id,
          value: study_id
        })}?${study_id !== null ? `study_id=${study_id}` : ''}${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${
          data.application
        }&deviation_level=${deviation_level}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateProtocolDeviationsLog: builder.mutation<any, any>({
      query: ({ data, deviation_level }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.update, {
          key: urlKeys.id,
          value: data.id
        })}?study_id=${data.study_id}&country=${data.country}&site_id=${
          data.site_id
        }&deviation_level=${deviation_level}&application=CTMS&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteProtocolDevationsLog: builder.mutation<any, any>({
      query: ({ id, study_id, country, site_id, application, deviation_level }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.delete, { key: urlKeys.id, value: id })}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&deviation_level=${deviation_level}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateDeviationAction: builder.mutation<any, any>({
      query: ({ id, data, study_id, country, site_id, application, deviation_level }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.updateDeviationAction, {
          key: urlKeys.id,
          value: id
        })}?${study_id !== null ? `study_id=${study_id}` : ''}${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&deviation_level=${deviation_level}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    UpdateDeviationDecision: builder.mutation<any, any>({
      query: ({ id, site_id, study_id, country, data, application, deviation_level }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.updateDeviationDecision, {
          key: urlKeys.id,
          value: encodeURIComponent(id)
        })}?${study_id !== null ? `study_id=${study_id}` : ''}${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&deviation_level=${deviation_level}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateAllProtocolDeviationsLog: builder.mutation<any, any>({
      query: ({ data, deviation_level }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.updateAll, {
          key: urlKeys.id,
          value: data.id
        })}?study_id=${data.study_id}&country=${data.country}&site_id=${
          data.site_id
        }&deviation_level=${deviation_level}&application=CTMS&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteAllProtocolDevationsLog: builder.mutation<any, any>({
      query: ({ id, study_id, country, site_id, application, deviation_level }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.deleteAll, { key: urlKeys.id, value: id })}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&deviation_level=${deviation_level}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    copyProtocolDeviationsLog: builder.mutation<any, any>({
      query: ({ data, study_id, country, site_id, application }) => ({
        url: `${formatString(
          endPoints.conductProtocolDeviationsLog.copy,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?${study_id !== null ? `study_id=${study_id}` : ''}${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getProtocolDeviationsLogBasedOnDateRange: builder.query<any, any>({
      query: ({ deviation_level, site_id, study_id, country, application, start_date, end_date, data }) => ({
        url: `${formatString(endPoints.conductProtocolDeviationsLog.getAll)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&deviation_level=${deviation_level}&application=${application}&start_date=${start_date}&end_date=${end_date}&application_section=CONDUCT&application_module_section=PROTOCOL DEVIATION LOG`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetProtocolDeviationsLogQuery,
  useCreateProtocolDeviationsLogMutation,
  useUpdateProtocolDeviationsLogMutation,
  useDeleteProtocolDevationsLogMutation,
  useUpdateDeviationActionMutation,
  useUpdateDeviationDecisionMutation,
  useUpdateAllProtocolDeviationsLogMutation,
  useDeleteAllProtocolDevationsLogMutation,
  useCopyProtocolDeviationsLogMutation,
  useLazyGetProtocolDeviationsLogBasedOnDateRangeQuery
} = protocolDeviationslogAPI;
